module.exports = __webpack_public_path__ + "404-page-image-desktop-b4b45b2f.jpg";